/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import env from "../../../../env";
import { usePost, Button, ErrorMessage } from "../../../../components";
import { useForm } from "../../../../form";
import { getSignupFormModel } from "./signupFormModel";
import cmsUtils from "cms/utils/cmsUtils";
import utils from "utils";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { set } from "date-fns";

function Portal({ children }) {
  const [el] = useState(document.createElement("div"));
  useEffect(() => {
    let mount = document.getElementById("portal-root");
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el]);
  return createPortal(children, el);
}

export function SignupForm(props) {
  const item = props.item;
  // const emailReceiver = cmsUtils.payload(item, "EmailReceiver");
  const emailReceiver = props.emailReceiver;
  const isMobile = utils.site.isMobile();
  

  const boxTitle = cmsUtils.payload(item, "Title");
  const boxSubTitle = cmsUtils.payload(item, "SubTitle");
  const backgroundImg = cmsUtils.payload(item, "ImageUrl");
  const [modalOpen, setModalOpen] = useState(false);
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  const [mobileSecondModalOpen, setMobileSecondModalOpen] = useState(false);
  const [thankyouModalOpen, setThankyouModalOpen] = useState(false);

  console.log("emailReceiver", boxSubTitle);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMobileModalOpen(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // if (JSON.parse(localStorage.getItem("donot")) === true) {
      //   setModalOpen(false);
      // } else {
      //   setModalOpen(true);
      // }
      setModalOpen(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (thankyouModalOpen === true) {
      const timer = setTimeout(() => {
        setThankyouModalOpen(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [thankyouModalOpen]);

  // const doNotShow = () => {
  //   localStorage.setItem('donot', JSON.stringify(true));
  //   setModalOpen(false);
  // }

  const model = getSignupFormModel({});
  const form = useForm(model, { usePlaceholder: true });
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const post = usePost();

  function onSubmit(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      // var files = form.getFiles();
      // var formData = new FormData();
      // formData.append("jsonData", JSON.stringify(value));
      // files.forEach((file) => {
      //   (file.files || []).forEach((uploadFile) => {
      //     formData.append(file.name, uploadFile);
      //   });
      // });
      // post.sendFormData(env.apiBase + "/api/signup/send", formData);
      post.send(env.apiBase + "/api/signup/send", value);
      setSendingStatus("pending");
    });
    e.preventDefault();
    // console.log("submitting");
  }

  if (post.done() && sendingStatus === "pending") {
    form.reset(model);
    setSendingStatus(null);
    setModalOpen(false);
    setThankyouModalOpen(true);
  }

  const render = (name) => form.renderControl(name, null);

  return (
    <div>
      {isMobile ? (
        // FIRST MODAL
        mobileModalOpen && (
          <Portal>
              <div className="firstSignUpFormContainer">
                <div className='signUpFormInside'>
                  <div
                    className='close_btn'
                    onClick={() => setMobileModalOpen(!mobileModalOpen)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      strokeWidth={1.5}
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M6 18 18 6M6 6l12 12'
                      />
                    </svg>
                  </div>
                  {/*<p className='mobileFirstText'>Join the VS VIP's</p>*/}
                  <p className='mobileFirstText'>{boxTitle}</p>
                  {/*<p className='boxSubTitle'>{boxSubTitle}</p>*/}
                  <div className="form-row">
                    <div className='col-md-12 mb-2'>
                      <div className='actions'>
                        <Button onClick={() => {
                          setMobileSecondModalOpen(!mobileSecondModalOpen);
                        }}>
                          {" "}
                          Subscribe{" "}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SECOND MODAL */}
              {mobileSecondModalOpen && (<Portal>
                <div className='mobileSignUpFormContainer'>
            <form
            className='mobileSignUpForm'
            >
            <div className='signUpFormInside'>
              <div className="formHeroImage"></div>
            <div
                    className='close_btn'
                    onClick={() => {
                      setMobileSecondModalOpen(false)
                      setMobileModalOpen(false)
                    }}
                  >
                    {/*<svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      strokeWidth={1.5}
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M6 18 18 6M6 6l12 12'
                      />
                    </svg>*/}
                    <img src='/assets/icons/icons-close.svg' alt='close' />
                  </div>
                  {/*<div className="formHeroImage">
                  </div>*/}
                  <div className='formContent'>
                    {/*<img src='/assets/join-us-banner.jpg' alt='lady-with-love' />*/}
                    <p className='boxTitle'>{boxTitle}</p>
                    <p className='boxSubTitle'>{boxSubTitle}</p>
                  </div>
                  <div className='form-row'>
                    <label>Email*</label>
                    <div className='col-md-12 mb-2'>{render("email")}</div>
                  </div>
                  <div className='form-row'>
                      <label>First Name*</label>
                    <div className='col-md-12 mb-2'>{render("firstName")}</div>
                  </div>
                  <div className='form-row'>
                    <label>Last Name*</label>
                    <div className='col-md-12 mb-2'>{render("lastName")}</div>
                  </div>
                  <div className='form-row'>
                    {/*<label>Province / State*</label>*/}
                    <div className='col-md-12 mb-2'>{render("state")}</div>
                  </div>
                  <div>
                    <div className='col-md-12 mb-2'>
                      <div className='actions'>
                        <Button onClick={onSubmit} status={post.status}>
                          {" "}
                          Subscribe{" "}
                        </Button>
                        {/*<button 
                          type='submit'
                          className={`btn btn-primary undefined`} 
                          onClick={() => {
                            onSubmit()
                            setThankyouModalOpen(!thankyouModalOpen)
                            setModalOpen(false)
                        }}>Subscribe</button>*/}
                        <ErrorMessage
                          errors={form.errors}
                          summaryMessage='Please review the errors.'
                        />
                        <ErrorMessage errors={post.errors} />
                      </div>
                      {/*<div className="actions2">
                        <Button onClick={() => doNotShow()}>Don't show again</Button>
                      </div>*/}
                    </div>
                  </div>
                  
                  {/*<p className='policy'>*Unsubscribe anytime.</p>*/}
                  <p className='policy'>
                    By clicking “Subscribe” you agree to receive marketing material from VS Sassoon. Your data will be held in accordance with our <a href='/privacy'>Privacy Policy</a>.{" "}
                  </p>
                </div>
              </form>
            </div>
              </Portal>
              )}
          </Portal>
        )
      ) : modalOpen && (
        <Portal>
          {modalOpen && (
            <React.Fragment>
              <div className="modal-bg"></div>
              <div className="signUpModal">
                <div
                    className='close_btn'
                    onClick={() => setModalOpen(false)}
                  >
                    {/*<svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      strokeWidth={1.5}
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M6 18 18 6M6 6l12 12'
                      />
                    </svg>*/}
                    <img src='/assets/icons/icons-close.svg' alt='close' />
                  </div>
                <div className='signUpFormContainer'>
              
            <form
            className='signUpForm'
            >
            <div className='signUpFormInside'>
              <div className="formHeroImage"></div>
            
                  <div className='formContent'>
                    {/*<img src='/assets/join-us-banner.jpg' alt='lady-with-love' />*/}
                    <p className='boxTitle'>{boxTitle}</p>
                    <p className='boxSubTitle'>{boxSubTitle}</p>
                  </div>
                  <div className='form-row'>
                    <label>Email*</label>
                    <div className='col-md-12 mb-2'>{render("email")}</div>
                  </div>
                  <div className='form-row'>
                  <label>First Name*</label>
                    <div className='col-md-12 mb-2'>{render("firstName")}</div>
                  </div>
                  <div className='form-row'>
                    <label>Last Name*</label>
                    <div className='col-md-12 mb-2'>{render("lastName")}</div>
                  </div>
                  <div className='form-row'>
                    {/*<label>Province / State*</label>*/}
                    <div className='col-md-12 mb-2'>{render("state")}</div>
                  </div>
                  <div>
                    <div className='col-md-12 mb-2'>
                      <div className='actions'>
                        <Button onClick={
                          onSubmit
                          }
                          status={post.status}>
                          {" "}
                          Subscribe{" "}
                        </Button>
                        {/*<Button onClick={() => {
                          setThankyouModalOpen(!thankyouModalOpen);
                          setModalOpen(false)
                        }}>
                          {" "}
                          Subscribe{" "}
                        </Button>*/}
                        <ErrorMessage
                          errors={form.errors}
                          summaryMessage='Please review the errors.'
                        />
                        <ErrorMessage errors={post.errors} />
                        {post.done() && (
                          <span
                            style={{
                              marginLeft: "1.5rem",
                              color: "red",
                              fontWeight: "bold",
                            }}
                          >
                            Successfully sent!
                          </span>
                        )}
                      </div>
                      {/*<div className="actions2">
                        <Button onClick={() => doNotShow()}>Don't show again</Button>
                      </div>*/}
                    </div>
                  </div>
                  
                  {/*<p className='policy'>*Unsubscribe anytime.</p>*/}
                  <p className='policy'>
                    By clicking “Subscribe” you agree to receive marketing material from VS Sassoon. Your data will be held in accordance with our <a href='/privacy'>Privacy Policy</a>.{" "}
                  </p>
                </div>
              </form>
            </div>
            </div>
            </React.Fragment>
          )}
          {/*{thankyouModalOpen && (
            <Portal>
              <div className='thankYouModalContainer'>
              <div
                    className='close_btn'
                    onClick={() => {
                      setThankyouModalOpen(false)
                      setModalOpen(false)
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      strokeWidth={1.5}
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M6 18 18 6M6 6l12 12'
                      />
                    </svg>
                  </div>
                <p className='thankYouModalTitle'>Thank you for subscribing!</p>
              </div>
            </Portal>
          )}*/}
        </Portal>
      )}
      {thankyouModalOpen && (
            <Portal>
              <div id='thankyouModal' className='thankYouModalContainer'>
                <p className='thankYouModalTitle'>
                  <div
                      className='close_btn'
                      onClick={() => {
                        setThankyouModalOpen(false)
                        setModalOpen(false)
                      }}
                    >
                      {/*<svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        strokeWidth={1.5}
                        stroke='currentColor'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M6 18 18 6M6 6l12 12'
                        />
                      </svg>*/}
                      <img src='/assets/icons/icons-close.svg' alt='close' />
                    </div>
                    Thanks for subscribing!
                  </p>
              </div>
            </Portal>
          )}
    </div>
  );
}
